import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import logo from '../images/logo-negative.png';
import beef from "../images/landing/beef.jpg"
import ribs from "../images/landing/ribs.jpg"
import sigleBottle from "../images/landing/singleBottle.png"
import twoBottles from "../images/landing/twoBottles.png"
import iconCheck from '../images/landing/check.svg';
import iconAlarm from '../images/landing/alarm.svg';
import iconLeaf from '../images/landing/leaf.svg';
import iconStars from '../images/landing/stars.svg';
import Footer from '../components/Footer';

const testimonials = [
  {
    name: 'Chris D.',
    text: "I've tried dozens of rubs, but nothing compares to this mix. It brought out flavors I didn't even know existed! Now everyone at the cookout asked what my secret was!",
    rating: 5,
    city: 'Austin',
    state: 'TX',
  },
  {
    name: 'Amanda K.',
    text: "This rub has transformed weeknight meals into a gourmet experience. It's perfectly balanced—sweet, smoky, and just enough heat. We're grilling without it again.",
    rating: 5,
    city: 'Denver',
    state: 'CO',
  },
  {
    name: 'Leo G.',
    text: "As someone who's gotten serious in local BBQ contests, I'll say this is the only thing that gives me a real edge. The depth of flavor is perfect.",
    rating: 5,
    city: 'Nashville',
    state: 'TN',
  },
  {
    name: 'James H.',
    text: "My kids and I are huge fans. Spice blends in the past were either gritty or overpowering. This is perfectly mixed, and every cut of meat tastes incredible.",
    rating: 5,
    city: 'Seattle',
    state: 'WA',
  },
  {
    name: 'Samantha P.',
    text: "LOVE RUB is a game changer! My brisket has never tasted better. The sweet and smoky notes are just right.",
    rating: 5,
    city: 'Chicago',
    state: 'IL',
  },
  {
    name: 'Mike T.',
    text: "I use it on everything—ribs, chicken, even veggies. My family asks for it by name!",
    rating: 5,
    city: 'Phoenix',
    state: 'AZ',
  },
  {
    name: 'Priya S.',
    text: "The only rub I trust for competition BBQ. It always gets compliments from the judges.",
    rating: 5,
    city: 'Dallas',
    state: 'TX',
  },
  {
    name: 'Carlos M.',
    text: "The flavor is bold but not overpowering. It's now a staple in my kitchen.",
    rating: 5,
    city: 'Miami',
    state: 'FL',
  },
];

const LoveRub = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    const prevBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = 'black';

    // Create Intersection Observer
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observerRef.current.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    });

    // Observe all sections
    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observerRef.current.observe(el);
    });

    return () => {
      document.body.style.backgroundColor = prevBg;
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="bg-black min-h-screen w-full text-white flex flex-col">
      <div className="flex-1">
        {/* Hero Section */}
        <div className="relative w-full flex flex-col md:flex-row items-center justify-center px-4 py-40 bg-black">
          {/* Background Image with Gradient Overlay */}
          <div className="absolute inset-0 w-full h-full">
            <img
              src={beef}
              alt="Love Rub Hero"
              className="w-full h-full object-cover opacity-40 pointer-events-none"
            />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_40%,_rgba(0,0,0,0.95)_60%,_rgba(0,0,0,1)_100%)]"></div>
          </div>

          {/* Content Container */}
          <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
            {/* Text Content */}
            <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left px-10 animate-on-scroll opacity-0">
              <img src={logo} alt="Badass BBQs Logo" className="h-14 sm:h-20 md:h-28 mb-4 sm:mb-6 transform hover:scale-105 transition-transform duration-300" />
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 sm:mb-6 leading-tight bg-gradient-to-r from-white to-white/80 bg-clip-text text-transparent">
                Give Your Meat Some Love
              </h1>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-8 text-white/90 max-w-xl">
                Welcome to BadassBBQs. Meet LOVE RUB – your meat's new best friend. This badass BBQ rub features a perfect sweet & smoky fusion, amazing bark, and serious flavor. Use it on everything and experience the bold, smoky, mouthwatering edge you crave.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                <a href="/custom-product" className="bg-red hover:bg-red/90 text-white font-bold py-3 px-8 sm:px-12 text-base sm:text-lg shadow-lg transition-all duration-300 transform hover:scale-105 text-center hover:shadow-red/50">
                  Order Now
                </a>
                <a href="/custom-product" className="bg-white/10 hover:bg-white/20 text-white font-bold py-3 px-8 sm:px-12 text-base sm:text-lg shadow-lg transition-all duration-300 transform hover:scale-105 text-center backdrop-blur-sm hover:shadow-white/20">
                  Learn More
                </a>
              </div>
            </div>

            {/* Product Image */}
            <div className="w-full md:w-1/2 flex justify-center items-center mt-8 md:mt-0 animate-on-scroll opacity-0">
              <div className="relative group">
                <img 
                  src={twoBottles} 
                  alt="Love Rub Bottle" 
                  className="h-48 sm:h-60 md:h-80 lg:h-[500px] drop-shadow-2xl w-auto max-w-full transform group-hover:scale-105 transition-all duration-500 hover:rotate-1" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            </div>
          </div>
        </div>

        {/* What Makes It Special */}
        <section className="bg-black py-12 sm:py-16 md:py-20 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12 sm:mb-16 md:mb-20 animate-on-scroll opacity-0">What Makes It Special?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mx-auto text-center max-w-7xl">
            {[
              { icon: iconCheck, title: "Sweet & Smoky Fusion", desc: "Perfectly balanced for a bold, crave-worthy flavor." },
              { icon: iconAlarm, title: "Perfect Crust, Every Time", desc: "Beautiful, caramelized bark on every cut." },
              { icon: iconLeaf, title: "All-Natural Ingredients", desc: "No fillers, no junk—just pure flavor." },
              { icon: iconStars, title: "Insanely Versatile", desc: "Great on beef, chicken, pork, and even veggies." }
            ].map((item, index) => (
              <div key={index} className="p-4 transform hover:scale-105 transition-all duration-300 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 200}ms` }}>
                <img src={item.icon} alt={`${item.title} Icon`} className="mx-auto mb-3 h-8 w-8 sm:h-10 sm:w-10 transform hover:rotate-12 transition-transform duration-300" style={{ filter: 'invert(1)' }} />
                <h3 className="font-bold text-base sm:text-lg mb-2">{item.title}</h3>
                <p className="text-sm sm:text-base text-white/80">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Where This Shines */}
        <section className="relative py-12 sm:py-16 md:py-[100px] px-4">
          <div className="absolute inset-0 w-full h-full">
            <img
              src={ribs}
              alt="where this shines"
              className="absolute inset-0 w-full h-full object-cover opacity-30 pointer-events-none"
            />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_20%,_rgba(0,0,0,0.95)_60%,_rgba(0,0,0,1)_100%)]"></div>
          </div>
          <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-stretch text-center md:text-left">
            <div className="w-full md:w-1/2 flex flex-col justify-center animate-on-scroll opacity-0">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Where This Shines</h2>
              <ul className="text-xl sm:text-2xl md:text-3xl text-white/90 mb-6 space-y-3 sm:space-y-4">
                {[
                  "Ribs that fall off the bone",
                  "Juicy grilled chicken",
                  "Smoked brisket masterpieces",
                  "Pork shoulders, wings, and even veggies"
                ].map((item, index) => (
                  <li key={index} className="transform hover:translate-x-2 transition-transform duration-300 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                    • {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="w-full md:w-1/2 flex justify-center items-center mt-8 md:mt-0 animate-on-scroll opacity-0">
              <img src={logo} alt="Badass BBQs Logo" className="mx-auto h-[150px] sm:h-[200px] transform hover:scale-110 transition-transform duration-300" />
            </div>
          </div>
        </section>

        {/* Why Choose Love Rub */}
        <section className="relative py-12 sm:py-16 md:py-20 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-8 sm:mb-12 md:mb-14 text-red-500 drop-shadow-lg tracking-tight animate-on-scroll opacity-0">Why Choose LOVE RUB?</h2>
          <div className="mx-auto flex flex-col md:flex-row gap-8 md:gap-0 bg-black/70 rounded-2xl sm:rounded-3xl shadow-2xl overflow-hidden border border-zinc-800 max-w-7xl animate-on-scroll opacity-0">
            <div className="w-full md:w-1/2 space-y-6 sm:space-y-8 p-6 sm:p-8 md:p-12 flex flex-col justify-center">
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed transform hover:translate-x-2 transition-transform duration-300">
                When it comes to BBQ, <span className="font-bold text-red">good flavor</span> isn't just an option — it's the <span className="font-bold">whole point</span>.<br/>
                That's why we created <span className="font-bold text-red">LOVE RUB</span> — a bold, handcrafted seasoning blend made for true flavor lovers.
              </p>
              <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed transform hover:translate-x-2 transition-transform duration-300">
                Whether you're firing up the smoker, lighting the grill, or roasting in the oven, <span className="font-bold text-red">LOVE RUB</span> is designed to bring out the very best in your meat.<br/>
                The perfectly balanced mix of sweet, smoky, and savory spices adds irresistible depth to ribs, chicken, pork, beef, seafood, and even veggies.
              </p>
            </div>
            <div className="hidden md:flex flex-col justify-center items-center px-2">
              <div className="w-1 h-40 bg-gradient-to-b from-red-500 via-yellow-400 to-red-500 rounded-full shadow-lg animate-pulse"></div>
            </div>
            <div className="w-full md:w-1/2 space-y-6 sm:space-y-8 p-6 sm:p-8 md:p-12 flex flex-col justify-center bg-zinc-900/60">
              <p className="font-bold text-white text-lg sm:text-xl mb-2 tracking-wide transform hover:translate-x-2 transition-transform duration-300">More than just a rub — it's an <span className="text-red">attitude</span>.<br/>When you season with LOVE RUB, you're telling the world:</p>
              <ul className="list-none space-y-3 mb-4">
                <li className="flex items-center text-base sm:text-lg md:text-xl transform hover:translate-x-2 transition-transform duration-300">
                  <span className="mr-3 text-xl sm:text-2xl animate-bounce-subtle">👉</span>
                  <span>You take pride in your BBQ</span>
                </li>
                <li className="flex items-center text-base sm:text-lg md:text-xl transform hover:translate-x-2 transition-transform duration-300">
                  <span className="mr-3 text-xl sm:text-2xl animate-bounce-subtle">👉</span>
                  <span>
                    You know how to <span className="font-semibold text-red">treat</span> your meat
                  </span>
                </li>
                <li className="flex items-center text-base sm:text-lg md:text-xl transform hover:translate-x-2 transition-transform duration-300">
                  <span className="mr-3 text-xl sm:text-2xl animate-bounce-subtle">👉</span>
                  <span>
                    And you're not afraid to add a little <span className="font-semibold text-red">LOVE</span> to every bite
                  </span>
                </li>
              </ul>
              <p className="text-white/90 text-base sm:text-lg md:text-xl transform hover:translate-x-2 transition-transform duration-300">So grab a bottle, shake it generously, and let <span className="font-bold text-red">LOVE RUB</span> turn every meal into a <span className="font-bold">crowd-pleasing masterpiece</span>.</p>
              <p className="text-xl sm:text-2xl text-center mt-6 sm:mt-8 font-extrabold text-red drop-shadow-lg animate-pulse">🔥 Give your meat some LOVE — and taste the difference. 🔥</p>
            </div>
          </div>
        </section>

        {/* Order Now Section */}
        <section className="bg-black py-12 sm:py-16 px-4 flex flex-col md:flex-row items-center justify-center gap-8 sm:gap-12">
          <img src={sigleBottle} alt="Love Rub Bottle" className="h-[300px] sm:h-[400px] md:h-[500px] drop-shadow-xl transform hover:scale-105 transition-all duration-500 animate-on-scroll opacity-0" />
          <div className="text-center md:text-left w-full md:w-1/2 px-4 sm:px-8 md:px-20 animate-on-scroll opacity-0">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4">Order Now</h2>
            <p className="text-2xl sm:text-3xl font-extrabold text-red-500 mb-2 animate-pulse">$15.99</p>
            <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-10 text-white/50">Spice up your grill and impress your guests. Add LOVE RUB to your cart and make every cookout unforgettable.</p>
            <a href="/custom-product" className="bg-red text-white font-bold py-2 sm:py-3 px-10 sm:px-20 text-base sm:text-lg shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-red/50 inline-block">Order Now</a>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-black py-12 sm:py-16 px-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-4 sm:mb-6 text-red-500 drop-shadow-lg tracking-tight animate-on-scroll opacity-0">What Our Customers Are Saying</h2>
          <p className="text-center text-white/70 text-base sm:text-lg max-w-2xl mx-auto mb-8 sm:mb-12 animate-on-scroll opacity-0">Discover how LOVE RUB has transformed ordinary meals into unforgettable BBQ experiences—straight from the grills of our satisfied customers. Real reviews, real flavor, real results.</p>
          <div className="mx-auto max-w-7xl">
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={3}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={4000}
              arrows={false}
              responsive={[
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 640, settings: { slidesToShow: 1 } }
              ]}
            >
              {testimonials.map((t, i) => (
                <div key={i} className="px-2 sm:px-4 py-4 sm:py-8">
                  <div className="bg-zinc-900/90 rounded-xl sm:rounded-2xl shadow-xl p-6 sm:p-8 flex flex-col items-start justify-center border border-zinc-800 h-full min-h-[280px] sm:min-h-[320px] transform hover:scale-105 transition-all duration-300 animate-on-scroll opacity-0" style={{ animationDelay: `${i * 100}ms` }}>
                    <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4 w-full">
                      <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-zinc-700 flex items-center justify-center text-xl sm:text-2xl font-bold text-white border-2 border-red transform hover:scale-110 transition-transform duration-300">
                        <span>{t.name[0]}</span>
                      </div>
                      <div>
                        <p className="font-semibold text-base sm:text-lg text-white text-left">{t.name}</p>
                        <div className="flex gap-1">
                          {Array.from({ length: t.rating }).map((_, idx) => (
                            <span key={idx} className="text-yellow-400 text-base sm:text-lg animate-bounce-subtle" style={{ animationDelay: `${idx * 100}ms` }}>★</span>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-white/90 italic text-base sm:text-lg text-left flex-1 transform hover:translate-x-2 transition-transform duration-300">"{t.text}"</p>
                    <p className="text-white/60 text-sm sm:text-base text-left mt-2">{t.city}, {t.state}</p>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        <style jsx>{`
          .animate-on-scroll {
            transition: opacity 0.6s ease-out, transform 0.6s ease-out;
          }

          .animate-fade-in {
            opacity: 1 !important;
            transform: translateY(0) !important;
          }

          .animate-bounce-subtle {
            animation: bounce-subtle 1s infinite;
          }

          @keyframes bounce-subtle {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-3px);
            }
          }

          
        `}</style>
      </div>
      <div className='-mb-[120px]'>   
        <Footer showTestimonials={false} />
      </div>
    </div>
  );
};

export default LoveRub; 